import styled from 'styled-components';

export const Icon = styled.img`
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  margin: ${(props) => props.margin || '0 10px'};

  :hover {
    cursor: pointer;
  }
`;

// Botao de acao com <Icon /> Lucide dentro — substitui o padrao antigo
// de trocar src entre EditarIconBlue (hover) / EditarIconGray (default).
// Cor herdada via currentColor, transicao suave no hover.
export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 4px;
  margin: 0;
  cursor: pointer;
  color: ${(props) => props.theme.colors.label};
  transition: color 150ms ease;

  &:hover {
    color: ${(props) => props.theme.colors.lightblue};
  }
`;

export const ContainerEmpty = styled.div`
  display: flex;
  width: ${(props) => props.width};
  height: ${(props) => (props.height ? props.height : '60vh')};
  background: ${(props) => props.theme.colors.card};
  overflow: hidden;
  border-radius: 10px;
  padding: 15px;
  box-sizing: border-box;
  flex-wrap: ${(props) => (props.wrap ? 'wrap' : 'unset')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: ${(props) => (props.weight ? props.weight : 600)};
  color: ${(props) => (props.color ? props.color : props.theme.colors.label)};
  padding-right: ${(props) => (props.padding ? props.padding : "0px")};
`;


export const IconEmpty = styled.img`
  width: ${(props) => (props.width ? props.width : '100px')};
  height: ${(props) => (props.height ? props.height : '100px')};
  margin: 15px;
`;

export const SpanEmpty = styled.span`
  color: ${(props) => props.theme.colors.disabled};
  margin: 1.5vh;
  font-size: 3.0vh;
  font-style: italic;
`;
